export default {
    baseUrlProd: '',// 正式环境域名
    // baseUrlDev: ''// 测试环境域名
    baseUrlDev: ''// 测试环境域名
}